var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 7H3.625C2.453 7 1.5 7.897 1.5 9V15C1.5 16.103 2.453 17 3.625 17H21.375C22.547 17 23.5 16.103 23.5 15V9C23.5 7.897 22.547 7 21.375 7ZM21.375 15H3.625C3.568 15 3.529 14.984 3.512 14.984C3.505 14.984 3.501 14.986 3.5 14.992L3.488 9.046C3.495 9.036 3.54 9 3.625 9H5.5V12H7.5V9H9.5V13H11.5V9H13.5V12H15.5V9H17.5V13H19.5V9H21.375C21.454 9.001 21.497 9.028 21.5 9.008L21.512 14.954C21.505 14.964 21.46 15 21.375 15Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.ab301bf1d0a134599cb0ab10f700bab2.svg";
export { ForwardRef as ReactComponent };